import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  note: {}
  bullets: { id: number }
  secondaryTextButton: {}
  secondaryButton: {}
  mainButton: {}
  learnMore: {}
}>('wixStudioBulletSplit')
